import { Button, Card, Row } from 'antd';
import React, { useState } from 'react'
import Heading from '../../../component/common/Heading';
import CRUDComponent from '../../../component/common/CRUD-Component';
import CONSTANTS from '../../../util/constant/CONSTANTS';
import { apiGenerator, convertUTCToLocal } from '../../../util/functions';
import useHttp from '../../../hooks/use-http';
import ModalFormCreator from '../../../component/common/ModalFormCreator';

const Banner = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const api = useHttp();
    const mappingOption = [
        {
            id: 1,
            Label: "Without Device",
            value: "withoutDevice",
        },
        {
            id: 2,
            Label: "With Device",
            value: "withDevice",
        },
        {
            id: 3,
            Label: "Without Feeder",
            value: "withoutFeeder",
        },
        {
            id: 4,
            Label: "With Feeder",
            value: "withFeeder",
        },
        {
            id: 5,
            Label: "General",
            value: "general",
        },
        {
            id: 6,
            Label: "Premium User",
            value: "premiumUser",
        },
        {
            id: 7,
            Label: "Sub Premium User",
            value: "subPremiumUser",
        },
    ]
    // Add Banner Handler
    const addBannerHandler = (value, clear) => {
        const formData = new FormData();
        value["redirectionLink"] && formData.append('redirectionLink', value?.redirectionLink)
        value["name"] && formData.append('name', value?.name)
        value['image'] && formData.append('image', value['image'][0].originFileObj);
        value?.allFlag?.forEach((ele, i) => {
            formData.append([`flag[${i}]`], ele)
        })
        const ADD_BANNER_API = { ...CONSTANTS.API.Banner.add };
        const EDIT_BANNER_API = apiGenerator(CONSTANTS.API.Banner.update, { id: editData?.id })

        if (editData) {
            api.sendRequest(EDIT_BANNER_API, (res) => {
                setRefresh(prev => !prev)
                setEditData(null)
                clear()
            }, formData, 'Edit Banner Successfully!!!')

        } else {
            api.sendRequest(ADD_BANNER_API, (res) => {
                setRefresh(prev => !prev)
                setIsOpen(prev => !prev)
                clear()
            }, formData, 'Add Banner Successfully!!!')
        }
    }
    return (
        <>
            <div>
                <Card className="my-5">
                    <Heading>Banner List</Heading>
                    <Button className='relative top-3' type='primary' onClick={() => setIsOpen(prev => !prev)}>
                        Add
                    </Button>
                    <ModalFormCreator
                        loading={api.isLoading}
                        open={isOpen || editData !== null}
                        onCreate={addBannerHandler}
                        onCancel={() => {
                            setIsOpen(false);
                            setEditData(null)
                        }}
                        menuFields={editData ? CONSTANTS.FORM_FIELD.EDIT_BANNER_MODAL : CONSTANTS.FORM_FIELD.BANNER_MODAL}
                        formData={editData ? editData : {}}
                        name={editData ? "Edit Banner" : "Add Banner"}
                        SubmitName={"Submit"}
                    />
                    <Row>
                        <CRUDComponent
                            reload={refresh}
                            GET={{
                                API: CONSTANTS.API.Banner.getAll,
                                DataModifier: (res, API, Setrefresh) => {
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `B${data?.id.toString().padStart(7, "0")}`,
                                            // flagD: data?.flag?.toString(),
                                            flagD: data?.flag?.map(ele => {
                                                return mappingOption.find(option => option.value === ele)?.Label
                                            })?.toString(),
                                            edit: {
                                                id: data?.id,
                                                onClick: () => {
                                                    setEditData({
                                                        ...data,
                                                        allFlag: data?.flag
                                                    })
                                                },
                                            }


                                        }
                                    });
                                },
                                column: CONSTANTS.TABLE.BANNER,
                            }}
                            isSearch
                            // CREATE={{
                            //     API: CONSTANTS.API.Banner.add,
                            //     isFormData: true,
                            //     message: "Created Banner successfully",
                            //     modaltitle: "Add Banner",
                            //     modalFields: CONSTANTS.FORM_FIELD.BANNER_MODAL,
                            //     beforePayloadModifier: (res) => {
                            //         // console.log(res);
                            //         let payload = {}
                            //         res?.allFlag?.forEach((ele, i) => {
                            //             payload = {
                            //                 ...payload,
                            //                 [`flag[${i}]`]: ele
                            //             }
                            //         })
                            //         payload = {
                            //             ...payload,
                            //             ...res
                            //         }

                            //         return payload;
                            //     },
                            // }}
                            // UPDATE={{
                            //     API: CONSTANTS.API.Banner.update,
                            //     message: "Edit Banner successfully",
                            //     modaltitle: "Edit Banner",
                            //     modalFields: CONSTANTS.FORM_FIELD.BANNER_MODAL,
                            //     payloadModifier: (res) => res,
                            // }}
                            DELETE={{
                                API: CONSTANTS.API.Banner.delete,
                                message: "Deleted Banner Successfully",
                            }}
                        />
                    </Row>
                </Card>

            </div>


        </>
    )
}

export default Banner